import React from 'react'
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PositiveNumInput from 'components/inputs/PositiveNumInput'
import MySpinner from 'components/MySpinner'
import { TOneItemCallback } from 'HttpRequests'

interface IQuantitySelectProps {
  quantity: number
  maxQuantity: number
  isLoading: boolean
  onChange: TOneItemCallback<number>
}

const QuantitySelect: React.FC<IQuantitySelectProps> = ({
  quantity,
  maxQuantity,
  isLoading,
  onChange,
}) => {
  const incQuant = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    if (!isLoading && quantity < maxQuantity) {
      onChange(quantity + 1)
    }
  }

  const decQuant = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    if (!isLoading && quantity > 1) {
      onChange(quantity - 1)
    }
  }

  const handleChange = (value: number | null) => {
    if (!value) {
      onChange(1)
    } else {
      onChange(value)
    }
  }

  return (
    <div className='d-flex col-gap-5'>
      <a
        className={isLoading || quantity <= 1 ? 'icon-grey' : 'icon-blue'}
        onClick={decQuant}
        href='/'
      >
        {isLoading ? (
          <MySpinner size='small' />
        ) : (
          <FontAwesomeIcon icon={faMinus} style={{ width: '15px' }} />
        )}
      </a>
      <PositiveNumInput
        value={quantity}
        maxValue={maxQuantity}
        onEntered={handleChange}
        disabled={isLoading}
        style={{ width: '50px', padding: '4px' }}
      />
      <a
        className={isLoading || quantity >= maxQuantity ? 'icon-grey' : 'icon-blue'}
        onClick={incQuant}
        href='/'
      >
        {isLoading ? (
          <MySpinner size='small' />
        ) : (
          <FontAwesomeIcon icon={faPlus} style={{ width: '15px' }} />
        )}
      </a>
    </div>
  )
}
export default QuantitySelect
